import PhotoSwipeLightbox from "photoswipe/lightbox";
const lightbox = new PhotoSwipeLightbox({
	gallery: ".photoswipe-lightbox",
	children: "a",
	bgOpacity: 0.85,
	pswpModule: () => import("photoswipe"),
	paddingFn: (viewportSize) => {
		return {
			top: 20,
			bottom: 20,
			left: viewportSize.x < 1024 ? 0 : 80,
			right: viewportSize.x < 1024 ? 0 : 80
		};
	},
});
const shopLighbox = new PhotoSwipeLightbox({
	gallery: ".photoswipe-shop-lighbox",
	children: "a",
	bgOpacity: 0.25,
	zoom: false,
	counter: false,
	closeSVG: '<svg xmlns="http://www.w3.org/2000/svg" class="size-10" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="1"><path stroke-linecap="square" stroke-linejoin="square" d="M6 18L18 6M6 6l12 12" /></svg>',
	pswpModule: () => import("photoswipe"),
	paddingFn: (viewportSize) => {
		return {
			top: viewportSize.x < 1024 ? 0 : 80,
			bottom: viewportSize.x < 1024 ? 0 : 80,
			left: viewportSize.x < 1024 ? 0 : 80,
			right: viewportSize.x < 1024 ? 0 : 80
		};
	},
});
lightbox.init();
shopLighbox.init();
